import { logger } from '@/utils/logger';
import { isDev, isCI } from '@/utils/helpers';
import axios, { type AxiosInstance } from 'axios';
import { correlationInterceptor, loggerInterceptor, csrfInterceptor } from '@zopauk/libs-axios';

let appInstance: AxiosInstance;

/**
 * Set the Galleria api axios instance
 *
 * @returns AxiosInstance
 */
const initAppInstance = () => {
  appInstance = axios.create({
    withCredentials: true,
    baseURL: '/api',
    timeout: 60000,
  });

  csrfInterceptor({ instance: appInstance });
  correlationInterceptor({ instance: appInstance });
  loggerInterceptor({
    identifier: 'CLIENT API',
    instance: appInstance,
    // Successful request/response bodies are only logged locally. Redacting DatoCMS content in the
    // browser (HTML with `=` is parsed as a query string) blocked the main thread for seconds (WEBE-27750).
    // Errors are still logged in every environment.
    verbose: isCI ? false : isDev,
    logger,
  });

  return appInstance;
};

export const getAppInstance = () => appInstance || initAppInstance();
